import "./App.css";
import "./assest/style/signin.css";
import "./assest/style/sidebar.css";
import "./assest/style/adminroutes.css";
import "./assest/style/input.css";
import "./assest/style/adminheader.css";
import "./users/templates/chatbot/chatbot.css";
import SiderbarContext from "./admin/context/SideBarStatusContext";
import ImageScrool from "./users/templates/animations/ImageScrool";
import AdminRoutes from "./Routes/AdminRoutes";
import { QueryClient, QueryClientProvider } from "react-query";
import AuthContextProvider from "./admin/context/AuthContext";
import OtpContext from "./context/OtpContext";
import RoutesPage from "./Routes/Routes";
import StickyContext from "./context/AboutScroolStickyContext";
import CaseStudyContext from "./context/CaseStudyContext";
import ExpertiseContext from "./context/EcpertiseContext";
// import SpinerLoading from "./common/Loading/SpinerLoading";
import ScrollToTops from "./common/ScroolTop";

const queryClient = new QueryClient();
function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthContextProvider>
        <OtpContext>
          <StickyContext>
            <CaseStudyContext>
              <ExpertiseContext>
                <div>
                 

                  <SiderbarContext>
                    {/* <ImageScrool /> */}
                    <RoutesPage />
                  </SiderbarContext>
              
                </div>
              
              </ExpertiseContext>
            </CaseStudyContext>
          </StickyContext>
        </OtpContext>
      </AuthContextProvider>
    </QueryClientProvider>
  );
}

export default App;
